const Zi_1=[
    {
        "Contig_Num":"1960",
        "Contig_Len":"806969902",
        "GC":"38.81",
        "Scaffold_Num":"1535",
        "Scaffold_Len":"807012402",
        "Gap_Num":"425",
        "Gap_Len":"42500"
    }
]
export default Zi_1